<template>
  <div class="layout-inner program_guide careers">

    <navbar></navbar>

    <div class="layout-container">
      <div class="layout-content">

        <template v-if="isLoading">
          <div class="w-100" style="padding: 150px 0;">
            <spinner size="large"></spinner>
          </div>
        </template>

        <template v-else>

          <template v-if="career && career.name">
            <career-title :career="career"></career-title>
          </template>

          <div class="container-fluid flex-grow-1 pg_content_container">
            <div class="">
              <div class="container">

                <div v-if="similarCareers && similarCareers.length > 0">
                  <h2>Similar</h2>
                  <div v-for="rC in similarCareers" class="">

                    <div class="row result_row">

                      <div class="col-2 thumbnail_container" @click.stop.prevent="goToCareerDetail(rC)">
                        <div class="thumbnail thumbnail_container" v-if="rC.thumbnailURI">
													<img v-bind:src="rC.thumbnailURI" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
												</div>
                        <div class="thumbnail_default_name" v-if="!rC.thumbnailURI" :style="{background:setThumbnailBgColor(rC.uuid)}">
                          <div class="txt_bx" v-html="setTitleInitials(rC.name)"></div>
                        </div>
                      </div>

                      <div class="col-9 entity_details">
                        <div class="row">
                          <div class="label" style="width: 95%;">
                            <a class="title" href="javascript://" @click.stop.prevent="goToCareerDetail(rC)" style="font-size: 16px; display: block;">
                              {{rC.name}}
                            </a>
                          </div>
                        </div>
                        <div class="row">
                          <div class="label">median income</div>
                          <div class="val" v-if="rC.medianEarning">
                            $<span v-html="addCommaInNumber(rC.medianEarning)"></span>
                          </div>
                          <div class="val no_data" v-else>
                            <span class="no_data_msg2">Data Unavailable</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="label">job postings</div>
                          <div class="val" v-if="rC.currentEmployment">
                            <span v-html="addCommaInNumber(rC.currentEmployment)"></span>
                          </div>
                          <div class="val no_data" v-else>
                            <span class="no_data_msg2">Data Unavailable</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="label">growth rate</div>
                          <div class="val" v-if="rC.growth">
                            <span v-html="formatNumericVal(rC.growth)"></span>
                          </div>
                          <div class="val no_data" v-else>
                            <span class="no_data_msg2">Data Unavailable</span>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

                <div v-if="feederCareers && feederCareers.length > 0">
                  <h2>Feeder</h2>
                  <div v-for="rC in feederCareers" class="">

                    <div class="row result_row">

                      <div class="col-2 thumbnail_container" @click.stop.prevent="goToCareerDetail(rC)">
                        <div class="thumbnail thumbnail_container" v-if="rC.thumbnailURI">
													<img v-bind:src="rC.thumbnailURI" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
												</div>
                        <div class="thumbnail_default_name" v-if="!rC.thumbnailURI" :style="{background:setThumbnailBgColor(rC.uuid)}">
                          <div class="txt_bx" v-html="setTitleInitials(rC.name)"></div>
                        </div>
                      </div>

                      <div class="col-9 entity_details">
                        <div class="row">
                          <div class="label" style="width: 95%;">
                            <a class="title" href="javascript://" @click.stop.prevent="goToCareerDetail(rC)" style="font-size: 16px; display: block;">
                              {{rC.name}}
                            </a>
                          </div>
                        </div>
                        <div class="row">
                          <div class="label">median income</div>
                          <div class="val" v-if="rC.medianEarning">
                            $<span v-html="addCommaInNumber(rC.medianEarning)"></span>
                          </div>
                          <div class="val no_data" v-else>
                            <span class="no_data_msg2">Data Unavailable</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="label">job postings</div>
                          <div class="val" v-if="rC.currentEmployment">
                            <span v-html="addCommaInNumber(rC.currentEmployment)"></span>
                          </div>
                          <div class="val no_data" v-else>
                            <span class="no_data_msg2">Data Unavailable</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="label">growth rate</div>
                          <div class="val" v-if="rC.growth">
                            <span v-html="formatNumericVal(rC.growth)"></span>
                          </div>
                          <div class="val no_data" v-else>
                            <span class="no_data_msg2">Data Unavailable</span>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

                <div v-if="advancementCareers && advancementCareers.length > 0">
                  <h2>Advancement</h2>
                  <div v-for="rC in advancementCareers" class="">

                    <div class="row result_row">

                      <div class="col-2 thumbnail_container" @click.stop.prevent="goToCareerDetail(rC)">
                        <div class="thumbnail thumbnail_container" v-if="rC.thumbnailURI">
													<img v-bind:src="rC.thumbnailURI" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
												</div>
                        <div class="thumbnail_default_name" v-if="!rC.thumbnailURI" :style="{background:setThumbnailBgColor(rC.uuid)}">
                          <div class="txt_bx" v-html="setTitleInitials(rC.name)"></div>
                        </div>
                      </div>

                      <div class="col-9 entity_details">
                        <div class="row">
                          <div class="label" style="width: 95%;">
                            <a class="title" href="javascript://" @click.stop.prevent="goToCareerDetail(rC)" style="font-size: 16px; display: block;">
                              {{rC.name}}
                            </a>
                          </div>
                        </div>
                        <div class="row">
                          <div class="label">median income</div>
                          <div class="val" v-if="rC.medianEarning">
                            $<span v-html="addCommaInNumber(rC.medianEarning)"></span>
                          </div>
                          <div class="val no_data" v-else>N/A</div>
                        </div>
                        <div class="row">
                          <div class="label">job postings</div>
                          <div class="val" v-if="rC.currentEmployment">
                            <span v-html="addCommaInNumber(rC.currentEmployment)"></span>
                          </div>
                          <div class="val no_data" v-else>N/A</div>
                        </div>
                        <div class="row">
                          <div class="label">growth rate</div>
                          <div class="val" v-if="rC.growth">
                            <span v-html="formatNumericVal(rC.growth)"></span>
                          </div>
                          <div class="val no_data" v-else>N/A</div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

                <div v-if="relatedCareers.length === 0" class="mt-5">
                  <div class="text-center">
                    <h4>No related careers available for this career</h4>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </template>

        <career-footer-navbar :pageTitle="'Related Careers'" :returnTo="'careerHome'" :params="{code: code, isComingFromBookmark: isComingFromBookmark}"></career-footer-navbar>

      </div>
    </div>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import CareerTitle from './CareerTitle'
  import Navbar from '../../misc/components/./Navbar'
  import CareerFooterNavbar from '../../misc/components/./CareerFooterNavbar'
  import VClamp from 'vue-clamp'

  export default {
    name: 'relatedCareers',
    props: ['code', 'isComingFromBookmark'],
    components: {
      Navbar,
      CareerTitle,
      CareerFooterNavbar,
      VClamp
    },
    data: () => {
      return {
        isLoading: true,
        relatedCareers: []
      }
    },

    mounted () {
      this.loadDataForCareerPrograms()
    },

    methods: {
      ...mapActions([
        'loadCareer',
        'loadUserObj',
        'loadRelatedCareers'
      ]),
      async loadDataForCareerPrograms () {
        await this.loadUserObj()
        await this.loadCareer(this.code)
        this.relatedCareers = await this.loadRelatedCareers(this.code)
        this.isLoading = false
      },
      setTitleInitials (streamTitle) {
        let getTitleInitials = streamTitle.match(/\b(\w)/g)
        return getTitleInitials.join('')
      },
      setThumbnailBgColor (entityId) {
        let getNumricValue = entityId.replace(/[^0-9]/g, '')
        return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
      },
      addCommaInNumber (numValue) {
        return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      formatNumericVal (numValue) {
				return parseFloat(numValue).toFixed(1)
			},
      goToProgramGuideDetail (major) {
        let routerParams = {
          code: this.code,
          cipCode: major.cipCode,
          programGuideCode: major.code,
          type: major.type,
          isComingFromBookmark: this.isComingFromBookmark
        }
        return this.$router.push({name: 'programGuideMenu', params: routerParams, query: {returnTo: 'careerPrograms', pageTitle: 'Programs'}})
      },
      hideUserNamePopup () {
        this.$refs.userNamePopupContainer.$emit('close')
      },
      goToCareerDetail (career) {
        return this.$router.push({name: 'careerHome', params: {code: career.pragyaSoc}, query: {returnTo: 'learnerDashboard', pageTitle: 'Back To Learner Dahsboard'}})
      }
    },
    computed: {
      ...mapState({
        'userObj': state => state.login.userObj,
        'career': state => state.career.careerObject
      }),
      similarCareers () {
      let similarCareers = []
      this.relatedCareers.forEach((item, i) => {
        if (item.relatedCareerType === 'lateralOccupations') {
          similarCareers.push(item)
        }
      })
      return similarCareers
    },
    feederCareers () {
      let feederCareers = []
      this.relatedCareers.forEach((item, i) => {
        if (item.relatedCareerType === 'feederOccupations') {
          feederCareers.push(item)
        }
      })
      return feederCareers
    },
    advancementCareers () {
      let advancementCareers = []
      this.relatedCareers.forEach((item, i) => {
        if (item.relatedCareerType === 'advancementOccupations') {
          advancementCareers.push(item)
        }
      })
      return advancementCareers
    }
    }
  }
</script>

<style scoped>
  .hd_bdr {
    width: 75px;
    height: 2px;
    float: left;
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
    background-color: #345237;
  }
</style>



// WEBPACK FOOTER //
// src/app/career/components/RelatedCareers.vue